import React from 'react';
import PropTypes from 'prop-types';

const MessageContainer = (props) => {
  const { fromMe, children } = props;
  return (
    <div
      className={fromMe ? 'ms-item right' : 'ms-item left'}
    >
      {children}
    </div>
  );
};

MessageContainer.propTypes = {
  fromMe: PropTypes.bool,
  children: PropTypes.any,
};

export default MessageContainer;
